const Theme = {
  body_background_color: 'black',

  header_border_style: 'dotted',
  header_border_height: 4,

  logo_image_url: 'cosmodome.png',
  logo_height: 150,

  number_font: 'serif',

  button_color: '#00ae9d',
  button_font: `'Gotham', sans-serif`,
  button_text_size: 14,
  button_radius: 50,

  button_half_border_color: '#00ae9d',
  button_half_font: `'Gotham', sans-serif`,
  button_half_text_size: 13,

  title_font: `'Houston Bold', sans-serif`,
  title_size: 40,
  title_lineheight: 40,

  subtitle_font: `'Gotham', sans-serif`,

  text_font: 'serif',
  text_size: 17,

  separator_color: '#00ae9d',
  separator_height: 2,
  separator_radius: 50,

  footer_font: `'Gotham', sans-serif`,
  footer_border_style: 'dotted',
  footer_border_height: 4,
}

export default Theme
